import { getW2Mappings } from "../utils";
import { UniversalExpanderDataColumn } from "../../UniversalExpanderDataColumn";
import { W2Form } from "../../../types";
import { DocumentCard } from "../../DocumentCard";

type W2DocDetailsProps = {
  forms?: W2Form[];
};

export const W2DocDetails = ({ forms }: W2DocDetailsProps) => {
  return forms?.map((form) => {
    const formData = getW2Mappings(form.raw_fields);

    return (
      <div key={form.uuid} className="flex flex-col gap-3">
        <div className="mt-3 border-b border-alpha-100">
          <p className="w-fit border-b-2 border-content-1000 text-content-1000 font-medium text-sm pb-2">
            Form W-2, {form.year}
          </p>
        </div>
        <DocumentCard
          score={
            form.doc_analysis.form_analysis[0]?.form_authenticity?.score || 0
          }
          asset={form.asset?.asset}
          reason_codes={
            form.doc_analysis.form_analysis[0]?.form_authenticity?.reason_codes
          }
        />
        <UniversalExpanderDataColumn
          title="Compensation and tax information"
          data={formData.compensationAndTaxInfoMappings}
        />
        <UniversalExpanderDataColumn
          title="Employer information"
          data={formData.employerInformationMappings}
        />
        <UniversalExpanderDataColumn
          title="Employee information"
          data={formData.employeeInformationMappings}
        />
        <UniversalExpanderDataColumn
          title="Additional Information"
          data={formData.additionalInformationMappings}
        />
      </div>
    );
  });
};
